import { useState, useCallback } from "react";
import { apiGet, apiPut } from "@/config";

export function useSiteSettings() {
  const [siteSettings, setSiteSettings] = useState({ intro_title: "", intro_content: "" });
  const [settingsError, setSettingsError] = useState(null);

  const fetchSettings = useCallback(async () => {
    try {
      const { data } = await apiGet("/settings");
      setSiteSettings(data);
      setSettingsError(null);
    } catch (err) {
      setSettingsError(err.message);
    }
  }, []);

  const saveSettings = useCallback(async (newSettings) => {
    await apiPut("/settings", newSettings);
    setSiteSettings(newSettings);
  }, []);

  return { siteSettings, settingsError, fetchSettings, saveSettings };
}
